import { render, staticRenderFns } from "./ContentDate.vue?vue&type=template&id=19cc0fa1&"
import script from "./ContentDate.vue?vue&type=script&lang=js&"
export * from "./ContentDate.vue?vue&type=script&lang=js&"
import style0 from "./ContentDate.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports